import { z } from 'zod';

// Contrato de firma compartido por los dos canales de invalidación de
// caché:
//   - API → web (endpoint `POST /api/revalidate` de la web).
//   - Core (BailaPro) → API (webhook de cambios de evento).
//
// La firma concreta (HMAC-SHA256) la calcula cada app con su propio
// `crypto` (Node), por eso aquí no hay runtime dependiente del entorno:
// solo vive el contrato (nombres de header, formato del string a firmar
// y tolerancia de timestamp) para que firmante y verificador no
// diverjan. Cada canal usa su propio secreto.

export const REVALIDATE_SIGNATURE_HEADER = 'x-baila-signature';
export const REVALIDATE_TIMESTAMP_HEADER = 'x-baila-timestamp';

// Ventana anti-replay: se rechazan firmas cuyo timestamp se aleje del
// reloj del verificador más que esto (en segundos).
export const REVALIDATE_TIMESTAMP_TOLERANCE_SECONDS = 300;

// String canónico a firmar: `${timestamp}.${rawBody}`. El timestamp
// entra en la firma para que la misma no pueda reutilizarse con otro
// cuerpo ni reproducirse pasada la ventana anti-replay.
export function buildRevalidateSigningString(
  timestamp: string | number,
  rawBody: string,
): string {
  return `${timestamp}.${rawBody}`;
}

// Cuerpo del POST que la API envía al endpoint de revalidación de la
// web. La web valida con este mismo schema.
export const RevalidateRequestSchema = z.object({
  tags: z.array(z.string().min(1)).min(1),
});

export type RevalidateRequest = z.infer<typeof RevalidateRequestSchema>;
